import { Linking, Platform } from "react-native";

export const openUrlInNewTab = async (url: string): Promise<void> => {
  if (Platform.OS === "web") {
    window.open(url, "_blank");
  } else {
    const canOpen = await Linking.canOpenURL(url);
    if (canOpen) await Linking.openURL(url);
  }
};

export const closeTab = (): void => {
  if (Platform.OS === "web") {
    window.close();
  }
};
